/**
 * Layout: Password
 * -----------------------------------------------------------------------------
 * Entry file for all global password scripts.
 * - All styles are included in critical-password.liquid snippet.
 *
 */

/**
 * Core scripts.
 */
import MainPassword from '~/components/main-password'
import Bugsnag from '~/core/bugsnag'
import { domReady } from '~/core/runners'

/**
 * Global Canvas variables.
 */
window.cnvs = window.cnvs || {}
window.cnvs.started = false

/**
 * DOM ready.
 */
domReady(() => {
  Bugsnag().init()
  MainPassword().init()
})
